import { IntlShape } from 'react-intl';
import { messages } from './messages';
import { ButtonSchema } from '@fhnw/schemas/button';
import { MediaSchema } from '@fhnw/schemas/media';

const Schema = (intl: IntlShape) => ({
  title: intl.formatMessage(messages.Leri),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['items'],
    },
  ],
  properties: {
    items: {
      title: intl.formatMessage(messages.Items),
      widgetOptions: {
        frontendOptions: {
          widget: 'custom_object_list_widget',
          widgetProps: {
            schema: {
              title: intl.formatMessage(messages.Item),
              addMessage: intl.formatMessage(messages.AddItem),
              fieldsets: [
                {
                  id: 'default',
                  title: 'Default',
                  fields: ['title', 'media', 'actions'],
                },
              ],
              properties: {
                title: {
                  title: intl.formatMessage(messages.Title),
                  widgetOptions: {
                    frontendOptions: {
                      widget: 'text',
                    },
                  },
                },
                media: {
                  title: intl.formatMessage(messages.Media),
                  widgetOptions: {
                    frontendOptions: {
                      widget: 'custom_object_widget',
                      widgetProps: {
                        schema: MediaSchema({ intl: intl }),
                      },
                    },
                  },
                },
                actions: {
                  title: intl.formatMessage(messages.Actions),
                  widgetOptions: {
                    frontendOptions: {
                      widget: 'custom_object_list_widget',
                      widgetProps: {
                        schema: ButtonSchema({ intl: intl }),
                      },
                    },
                  },
                },
              },
              required: [],
            },
          },
        },
      },
    },
  },
  required: [],
});

export default Schema;
